/** set types */
export const SET_COMPANIES = "SET_COMPANIES";
export const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY";
/** add types */
export const ADD_COMPANY = "ADD_COMPANY";
/** update types */
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const UPDATE_COMPANY_NAME = "UPDATE_COMPANY_NAME";
/** delete types */
export const DELETE_COMPANY = "DELETE_COMPANY";
